import { type Bucket } from 'investments/common/entities'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type UseQueryRequestOptions, queryClient, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

async function fetchBucketDetails({ accountId, bucketId }: { accountId: string; bucketId: string }) {
  const { data } = await httpClientBanking<Bucket>({
    url: `/investments/accounts/${accountId}/buckets/${bucketId}`
  })
  return { ...data }
}

export function getUseFetchBucketDetailsKey(accountId: string, bucketId: string) {
  return ['useFetchBucketDetails', accountId, bucketId] as const
}

export function invalidateUseFetchBucketDetailsQuery(accountId: string, bucketId: string) {
  return queryClient.invalidateQueries(getUseFetchBucketDetailsKey(accountId, bucketId))
}

export function useFetchBucketDetails({
  accountId,
  bucketId,
  options
}: {
  accountId: string
  bucketId: string
  options?: UseQueryRequestOptions<Bucket, unknown, true>
}) {
  const {
    data: bucketDetailsData,
    isLoading: isBucketDetailsLoading,
    isFetching: isBucketDetailsFetching,
    isRefetching: isBucketDetailsRefetching,
    error: bucketDetailsError,
    isError: isBucketDetailsError,
    isSuccess: isBucketDetailsSuccess
  } = useQueryRequest<Bucket, unknown, true>(
    getUseFetchBucketDetailsKey(accountId, bucketId),
    () => fetchBucketDetails({ accountId, bucketId }),
    { suspense: true, ...options }
  )
  return {
    bucketDetailsData,
    isBucketDetailsLoading,
    isBucketDetailsFetching,
    isBucketDetailsRefetching,
    bucketDetailsError,
    isBucketDetailsError,
    isBucketDetailsSuccess
  }
}
